// Line icons on a 24-point grid, drawn for the website (SF Symbols are for Apple platforms only).
// Category icons stand in for the SF Symbol each category uses in the app.

const paths: Record<string, string> = {
  // Navigation and actions
  trips: "M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01",
  mileage: "M5 20V11M12 20V5M19 20v-6M3 20h18",
  export: "M12 15V3M7.5 7.5 12 3l4.5 4.5M5 13v7h14v-7",
  person: "M12 4.4a3.6 3.6 0 1 1 0 7.2 3.6 3.6 0 0 1 0-7.2zM5 20a7 7 0 0 1 14 0",
  chevronDown: "m6 9 6 6 6-6",
  chevronUp: "m6 15 6-6 6 6",
  close: "M6 6l12 12M18 6 6 18",
  download: "M12 4v11M7.5 10.5 12 15l4.5-4.5M5 20h14",
  print: "M7 8V3.5h10V8M5 8h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M7 17H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2M7 14h10v6.5H7z",
  check: "m5 12.5 4.5 4.5L19 7.5",
  wand: "M5 19 15 9M13.5 7.5l3 3M18 3.5v3M16.5 5h3M19.5 10v2M18.5 11h2",
  roundTrip: "M4 9h13l-3-3M20 15H7l3 3",
  road: "M8 3 5 21M16 3l3 18M12 4v2.5M12 10.5v3M12 17.5V20",
  clock: "M12 3.5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17zM12 7.5V12l3 2",
  gauge: "M4 17a8 8 0 1 1 16 0M12 17l4-5",
  car: "M3.5 16.5V13l2.2-4.6a2 2 0 0 1 1.8-1.1h7.6a2 2 0 0 1 1.6.8l3.3 4.4h.5v4h-2M9.5 16.5h5M7 14.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM16.5 14.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4z",
  phone: "M9.5 2.5h5A2.5 2.5 0 0 1 17 5v14a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 7 19V5a2.5 2.5 0 0 1 2.5-2.5zM11 18.5h2",
  info: "M12 3.5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17zM12 11v5M12 8h.01",
  warning: "M12 4 2.8 19.5h18.4zM12 10v4.5M12 17.5h.01",
  trash: "M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3",
  signOut: "M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10",
  external: "M8 16 16 8M9 8h7v7",
  refresh: "M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7",
  cloudUp: "M7 18a4 4 0 0 1-.6-7.96A6 6 0 0 1 18 9a4.5 4.5 0 0 1-.5 9H7zM12 15v-5M9.5 12.5 12 10l2.5 2.5",
  cloudOff: "M7 18a4 4 0 0 1-.6-7.96A6 6 0 0 1 18 9a4.5 4.5 0 0 1-.5 9H7zM4 4l16 16",
  lock: "M7 11h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2zM8 11V7a4 4 0 0 1 8 0v4",
  calendar: "M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zM3 10h18M8 3v4M16 3v4",
  checklist: "M4 7l1.5 1.5L8 6M4 13l1.5 1.5L8 12M4 19l1.5 1.5L8 18M11 7h9M11 13h9M11 19h9",
  undo: "M9 14 4 9l5-5M4 9h10a6 6 0 0 1 0 12h-3",

  // Category symbols (by the SF Symbol name the app stores)
  "briefcase.fill": "M5.5 7h13A2.5 2.5 0 0 1 21 9.5v8a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 17.5v-8A2.5 2.5 0 0 1 5.5 7zM9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7M3 12.5h18",
  "house.fill": "M4 10.5 12 4l8 6.5V20H4zM10 20v-5h4v5",
  "building.2.fill": "M6.5 3h11A1.5 1.5 0 0 1 19 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3zM9 7h1M14 7h1M9 11h1M14 11h1M9 15h1M14 15h1M11 21v-3h2v3",
  "cross.case.fill": "M5.5 7h13A2.5 2.5 0 0 1 21 9.5v8a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 17.5v-8A2.5 2.5 0 0 1 5.5 7zM9 7V5h6v2M12 10.5v6M9 13.5h6",
  "heart.fill": "M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.2a4.3 4.3 0 0 1 7.5 2.6C19.5 15.4 12 20 12 20z",
  "tag.fill": "M3.5 12.2V4.5a1 1 0 0 1 1-1h7.7L21 12.3 12.3 21zM8 8h.01",
  "hammer.fill": "M14 4.5 19.5 10l-2 2L12 6.5zM12 6.5 4 14.5 6.5 17l8-8M10 4l2.5 2.5",
  "wrench.and.screwdriver.fill": "M14.5 4.5a4 4 0 0 0 5 5L11 18a2 2 0 1 1-3-3l8.5-8.5a4 4 0 0 0-2-2zM4 4l5 5M3 7l4-4",
  "shippingbox.fill": "M12 3 20 7.5v9L12 21l-8-4.5v-9zM4 7.5 12 12l8-4.5M12 12v9M8 5.3l8 4.5",
  "cart.fill": "M3 4h2.5l2.2 10.5h10l2-7.5H7M9.5 19a1.2 1.2 0 1 1 0 .1zM16.5 19a1.2 1.2 0 1 1 0 .1z",
  "bag.fill": "M5 8h14l-1 12H6zM9 8V6.5a3 3 0 0 1 6 0V8",
  "graduationcap.fill": "M12 5 2.5 9.5 12 14l9.5-4.5zM6.5 11.5V16c1.5 1.6 3.3 2.4 5.5 2.4s4-.8 5.5-2.4v-4.5M21 10v5",
  "figure.and.child.holdinghands": "M8 4.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM16.5 9a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2zM8 10v10M5 12.5l3-2 3.5 3h2.5M16.5 13.5V20",
  "person.2.fill": "M9 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM3.5 19.5a5.5 5.5 0 0 1 11 0M16 6a2.5 2.5 0 1 1 0 5M17 14.2a4.5 4.5 0 0 1 3.5 5.3",
  stethoscope: "M6 3.5v5a4 4 0 0 0 8 0v-5M10 12.5v2.5a4.5 4.5 0 0 0 9 0v-2M19 10a1.8 1.8 0 1 1 0 3.6 1.8 1.8 0 0 1 0-3.6z",
  "dumbbell.fill": "M3 9.5v5M6 7v10M18 7v10M21 9.5v5M6 12h12",
  "fork.knife": "M7 3v7a2 2 0 0 0 2 2v9M11 3v7a2 2 0 0 1-2 2M17 21V3c-2 1.5-3 4-3 7.5h3",
  airplane: "M10.5 20.5 12 17v-4.5l8 3v-2l-8-5V4.5a1.5 1.5 0 0 0-3 0v4l-8 5v2l8-3V17l1.5 3.5",
  "suitcase.fill": "M5.5 8h13A1.5 1.5 0 0 1 20 9.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5v-9A1.5 1.5 0 0 1 5.5 8zM9 8V5h6v3M9 8v12M15 8v12",
  "car.fill": "M3.5 16.5V13l2.2-4.6a2 2 0 0 1 1.8-1.1h7.6a2 2 0 0 1 1.6.8l3.3 4.4h.5v4h-2M9.5 16.5h5M7 14.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM16.5 14.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4z",
  "dog.fill": "M6 8 4 4l4 2h6l4-2-2 4v4a6 6 0 0 1-12 0zM9.5 11h.01M14.5 11h.01M11 15h2",
  "leaf.fill": "M5 19C5 10 10 5 20 4c0 10-5 15-14 15zM5 19l7-7",
  "star.fill": "m12 3.5 2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.8l-5.2 2.8 1-5.8L3.5 9.7l5.9-.8z",
  "book.fill": "M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5zM4 20.5A2.5 2.5 0 0 0 6.5 23H20v-5",
  "music.note": "M9 18V5l11-2v13M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM20 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0z",
  laptopcomputer: "M6 5h12a1.5 1.5 0 0 1 1.5 1.5V15.5h-15V6.5A1.5 1.5 0 0 1 6 5zM2.5 19h19",
};

export function hasIcon(name: string): boolean {
  return name in paths;
}

export function Icon({ name, size, label, className }: { name: string; size?: "sm" | "lg" | "xl"; label?: string; className?: string }) {
  const d = paths[name] ?? paths["tag.fill"];
  const classes = ["i", size ? `i-${size}` : "", className ?? ""].filter(Boolean).join(" ");
  return label
    ? <svg className={classes} viewBox="0 0 24 24" role="img" aria-label={label}><path d={d} /></svg>
    : <svg className={classes} viewBox="0 0 24 24" aria-hidden="true"><path d={d} /></svg>;
}
